<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <div class="flex-center gap-4">

        <v-btn
          v-if="isOIC && item.status === 'Submitted1'"
          small
          icon
          @click="onEdit(item.form_type)"
        >
          <Iconify icon="material-symbols:edit" size="15px"></Iconify>
        </v-btn>

        <v-btn small icon @click="onView(item?.form_type)">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
        <!-- <v-btn 
          v-if="item.status === 'Draft'"
          small icon 
          @click="onDelete(item.id)"
          >
                <Iconify
                    style="color: #b1b1b1"
                    icon="basil:trash-alt-solid"
                    size="15px"
                ></Iconify>
        </v-btn> -->
      </div>
    </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
      </div>
      <div
        :style="{ width: headers[2].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.main_project?.fiscal_year }}
      </div>
      <div
        :style="{ width: headers[3].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          style="height: 20px"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
        >
          <tooltip-text :text="item?.main_project?.name" />
        </div>
        <div
          v-if="item.main_project?.start_date && item.main_project?.end_date"
          class="one-line font-type-normal"
          style="height: 20px"
        >
          <tooltip-text
            :text="
              'ระยะเวลาเปิดรับโครงการ :' +
              toDateRangeFormat(
                item.main_project.start_date,
                item.main_project.end_date
              )
            "
          />
        </div>
      </div>
      <div :style="{ width: headers[4].width }">
        {{ item.region }}
      </div>
      <div
        :style="{
          width: headers[5].width,
          color: statusColorSeparator(item.status),
        }"
      >
        <div v-if="item.status === 'Submitted2'" class="d-flex gap-8">
          <Button height="36px" @onClick="onApproved"> Approved </Button>
          <Button theme="5" height="36px" @onClick="onRewindStatus"> ย้อนสถานะ </Button>
        </div>
        <div v-else>
          {{ item.status }}
        </div>
      </div>
      <div :style="{ width: headers[6].width }"></div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between gap-12 theme-color-eight">
          <div style="min-width: 8%; max-width: 8%">ลำดับ</div>
          <div style="min-width: 82%; max-width: 82%">แผนงาน</div>
          <div v-if="item.form_type !== 'D' && item.form_type !== 'F'" style="min-width: 8%; max-width: 8%" class="text-center">
            จำนวนผู้เชี่ยวชาญ
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div
          v-if="item.main_project && item.main_project.plan"
          class="d-flex flex-column gap-8"
        >
          <div v-for="(x, i) in item.main_project.plan" :key="i">
            <div class="d-flex justify-space-between align-center gap-12">
              <div style="min-width: 8%; max-width: 8%">
                {{ i + 1 }}
              </div>
              <div style="min-width: 82%; max-width: 82%">
                {{ x.plan_master?.plan_name_th }}
              </div>
              <div
                v-if="item.form_type !== 'D' && item.form_type !== 'F'"
                style="min-width: 8%; max-width: 8%; cursor: pointer"
                class="text-center underline-text"
                @click="viewConsiderResult(x.form_b.id)"
              >
                {{ x.form_b.evaluate_forms.length }}/{{ item.max_evaluator }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat } from "../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "ProjectOfferFromRSPItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
      max_evaluators: 0,
    };
  },
  computed: {
    ...mapState({
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Submitted1":
        case "Submitted2":
        case "Inception":
          this.theme = 5;
          return "#000";

        case "Approved":
        case "Completed":
          this.theme = 3;
          return "var(--theme-color-three)";
        default:
          return "#000";
      }
    },
    onEdit(type) {
      if(type === 'D'){
        this.$router.push({ name: "FormD", query: { id: this.item.main_project.plan[0].form_b.id } });
      }else if (type === 'F'){
        this.$router.push({ name: "FormF", query: { id: this.item.main_project.plan[0].form_b.id } });
      }else{
        this.$router.push({ name: "FormA", query: { id:  this.item.id } });
      }
      // this.$router.push({ name: "FormA", query: { id: this.item.id } });
    },
    onView(type) {
      if(type === 'D'){
        this.$router.push({
        path: `/project-d-form?id=${this.item.main_project.plan[0].form_b.id}&preview=true`,
      });
      }else if (type === 'F'){
        this.$router.push({
        path: `/project-f-form?id=${this.item.main_project.plan[0].form_b.id}&preview=true`,
      });
      }else{
        this.$router.push({
          path: `/project-a-form?id=${this.item.id}&preview=true`,
        });
      }
    
    },
    onApproved() {
      this.$emit("onApproved");
    },
    onRewindStatus() {
      this.$emit("onRewindStatus");
    },
    viewConsiderResult(id) {
      this.$router.push({
        name: "ConsiderResult",
        params: { form_b_id: id },
      });
    },
    onDelete(id) {
      console.log(id)
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("AForm/deleteFormAList",id);
          if (res) {
            // this.$store.commit("General/setModal", {
            //   title: "เสร็จสิ้น!",
            //   theme: "success",
            //   text: res,
            //   showCancel: false,
            // });
            window.location.reload();
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.underline-text{
  text-decoration:underline;
}
</style>
